import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMoon } from "@fortawesome/free-solid-svg-icons";
import { faSun } from "@fortawesome/free-regular-svg-icons";

import AudioPlayer from "./components/AudioPlayer/AudioPlayer";
import heroUrl from "./assets/hero_02.svg";

function App() {
  const [theme, setTheme] = useState(() => {
    return localStorage.getItem("theme") || "dark";
  });

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
    localStorage.setItem("theme", theme);
  }, [theme]);

  const toggleTheme = () => {
    setTheme((prev) => (prev === "dark" ? "light" : "dark"));
  };

  return (
    <div className="App">
      <div className="bgImage" style={{ backgroundImage: `url(${heroUrl})` }} />
      <button className="themeToggle" onClick={toggleTheme} aria-label="Toggle theme">
        <FontAwesomeIcon icon={theme === "dark" ? faSun : faMoon} />
      </button>
      <div className="heroWrap">
        <img src={heroUrl} className="heroImg" alt="" aria-hidden="true" />

      </div>
      <div className="container">
        <AudioPlayer audioSrc={null} />
      </div>
    </div>
  );
}

export default App;
